import { PROMOTION_TYPES } from '../types/types.ts';
import type { Product } from '../types/typesProduct.ts';
import { VOUCHER_EXTRA_TYPE } from '../types/typesProduct.ts';

export const getActivePromotions = (enabledPromotions: PROMOTION_TYPES[], product: Product): PROMOTION_TYPES[] => {
  const { promotions, rate } = product;
  const { flashSale, flashSaleExpiration, londonEye, tourFrance, voucher } = promotions;
  const { flags, packageDiscount, offers, price, features, tep } = rate;
  const { pinkPeople, mobile, tsh, myPrice, opx, voucherExtraType, loyalty } = flags;
  const { transfer, tickets, skiPass, spa, januarySale, resortCredit } = offers;
  const { depositAmount } = price;
  const { bookNowPayLater } = features;
  const tepEnabled = tep?.enabled;
  const packageDiscountEnabled = packageDiscount?.enabled;
  const plus = flags?.plus;

  const array: PROMOTION_TYPES[] = [];

  if (loyalty) {
    array.push(PROMOTION_TYPES.LOYALTY);
  }

  if (flashSale && flashSaleExpiration) {
    array.push(PROMOTION_TYPES.FLASH_SALES);
  }

  if (pinkPeople) {
    array.push(PROMOTION_TYPES.PINK_PEOPLE);
  }

  if (plus) {
    array.push(PROMOTION_TYPES.PLUS);
  }

  if (tsh) {
    array.push(PROMOTION_TYPES.TOP_SECRET_HOTELS);
  }

  if (myPrice) {
    array.push(PROMOTION_TYPES.MY_PRICE);
  }

  if (mobile) {
    array.push(PROMOTION_TYPES.APP_ONLY_PRICE);
    array.push(PROMOTION_TYPES.MOBILE_ONLY_PRICE);
  }

  if (londonEye) {
    array.push(PROMOTION_TYPES.LONDON_EYE);
  }

  if (tourFrance) {
    array.push(PROMOTION_TYPES.TOUR_DE_FRANCE);
  }

  if (januarySale) {
    array.push(PROMOTION_TYPES.JANUARY_SALE);
  }

  if (opx) {
    // to be enabled based on market
    array.push(PROMOTION_TYPES.TO);
    array.push(PROMOTION_TYPES.TO_LOGO);
    array.push(PROMOTION_TYPES.TO_WEGDE);
    array.push(PROMOTION_TYPES.TO_FR);
    array.push(PROMOTION_TYPES.TO_LASTMINUTE);
    array.push(PROMOTION_TYPES.CASHBACK);
  } else {
    array.push(PROMOTION_TYPES.FLEXMIX);
    array.push(PROMOTION_TYPES.IMMEDIATE_DISCOUNT);
  }

  if (tickets) {
    array.push(PROMOTION_TYPES.TICKETS);
  }

  if (transfer) {
    array.push(PROMOTION_TYPES.TRANSFER);
  }

  if (skiPass) {
    array.push(PROMOTION_TYPES.SKIPASS);
  }

  if (spa) {
    array.push(PROMOTION_TYPES.SPA);
  }

  if (resortCredit) {
    array.push(PROMOTION_TYPES.RESORT_CREDIT);
  }

  if (depositAmount) {
    array.push(PROMOTION_TYPES.DEPOSIT_AMOUNT);
  } else if (bookNowPayLater) {
    array.push(PROMOTION_TYPES.BOOK_NOW_PAY_LATER);
  }

  if (tepEnabled) {
    array.push(PROMOTION_TYPES.TRAVEL_EXTRA_PACK);
  }

  if (voucherExtraType === VOUCHER_EXTRA_TYPE.THIRTY || voucherExtraType === VOUCHER_EXTRA_TYPE.HUNDRED) {
    array.push(PROMOTION_TYPES.VOUCHER_EXTRA);
  }

  if (voucher?.code) {
    array.push(PROMOTION_TYPES.VOUCHER);
  }

  if (packageDiscountEnabled) {
    array.push(PROMOTION_TYPES.PACKAGE_SAVINGS);
  }

  return array.filter((promotion) => enabledPromotions.includes(promotion));
};
